import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';
import { Clamp, Relay, Probe, Pilotwire, Flowmeter, SensorClamp, SensorRelay, DriveElecClamp, DriveElecRelay } from '.';

class ProductModuleDetail extends PureComponent {
    static propTypes = {
        theme: PropTypes.object.isRequired,
        productIdentifier: PropTypes.string,
        productType: PropTypes.string,
        lineType: PropTypes.string,
        key: PropTypes.string
    };

    static defaultProps = {
        productIdentifier: null,
        productType: 'fhe_product',
        lineType: null,
        key: null
    };

    render() {
        const { lineType, productType } = this.props;
        const detailContentByType = {
            fhe_product: {
                clamp: () => <Clamp {...this.props} />,
                probe: () => <Probe {...this.props} />,
                pilotwire: () => <Pilotwire {...this.props} />,
                flowmeter: () => <Flowmeter {...this.props} />,
                relay: () => <Relay {...this.props} />,
                default: () => null
            },
            sensor: {
                clamp: () => <SensorClamp {...this.props} />,
                relay: () => <SensorRelay {...this.props} />,
                default: () => null
            },
            drive_elec: {
                clamp: () => <DriveElecClamp {...this.props} />,
                relay: () => <DriveElecRelay {...this.props} />,
                default: () => null
            }
        };
        return ((detailContentByType[productType] && detailContentByType[productType][lineType]) || detailContentByType['default'])();
    }
}

export default withTheme(ProductModuleDetail);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/components/ProductModule/ProductModuleDetail.js